import { createUseStyles } from 'react-jss';
// @todo: convince to drop support for `px` for `rem`. Better font scaling, means better a11y and responsiveness

const useStyles = createUseStyles((theme) => ({
  wrenchTypography: ({ align, color, variant }) => {
    const { typeColor, semanticColor, fontFamily, fontSize, fontWeight } =
      theme;

    const chosenColor = typeColor[color] || semanticColor[color];

    return {
      fontFamily: fontFamily.base,
      fontSize: fontSize.body,
      boxSizing: 'border-box',
      '-webkit-font-smoothing': 'antialiased',
      color: chosenColor,
      textAlign: align,
      lineHeight: 1.5,
      margin: 0,
      padding: 0,
      ...(variant &&
        variant !== 'link' && {
          fontSize: fontSize[variant],
          fontWeight: {
            hero1: fontWeight.light,
            hero2: fontWeight.light,
            title: fontWeight.light,
            sectionTitle: fontWeight.light,
            pageTitle: fontWeight.light,
            cardTitle: fontWeight.medium,
            body: fontWeight.regular,
            bodySm: fontWeight.regular,
          }[variant],
        }),

      ...(variant &&
        variant === 'link' && {
          color: typeColor.link,
          textDecoration: 'none',
          border: 'none',
          background: 'none',
          outline: 'none',
          cursor: 'pointer',
          fontWeight: 'inherit',
          fontSize: 'inherit',

          '&:hover, &:focus': {
            textDecoration: 'underline',
          },
        }),
    };
  },
}));

export default useStyles;
